import React, { useEffect, useState } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers";
import { Search } from "lucide-react";
import { AddCircleOutline, Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const uhidOptions = [
  { label: "Dummy data 1", value: "001" },
  { label: "Dummy data 2", value: "002" },
  { label: "Dummy data 003", value: "003" },
  { label: "Dummy data 004", value: "004" },
];
const INCLUDE_CATEGORY_LABEL = [
  {
    id: 1,
    label: "Category Name",
    value: "categoryName",
  },
  {
    id: 2,
    label: "Sub Category Name",
    value: "subCategoryName",
  },
  {
    id: 3,
    label: "Relief By",
    value: "reliefBy",
  },
  {
    id: 4,
    label: "Relief Type",
    value: "reliefType",
  },
  {
    id: 4,
    label: "Percentage",
    value: "percentage",
  },
  {
    id: 5,
    label: "Cash",
    value: "cash",
  },
  {
    id: 6,
    label: "Qty",
    value: "quantaty",
  },
  {
    id: 7,
    label: "",
    value: "",
  },
];
const INCLUDE_DEPARTMENT_LABEL = [
  {
    id: 1,
    label: "Department",
    value: "department",
  },
  {
    id: 2,
    label: "Relief By",
    value: "reliefBy",
  },

  {
    id: 3,
    label: "Relief Type",
    value: "reliefType",
  },
  {
    id: 4,
    label: "Percentage",
    value: "percentage",
  },
  {
    id: 5,
    label: "Cash",
    value: "cash",
  },
  {
    id: 6,
    label: "Qty",
    value: "quantaty",
  },
  {
    id: 7,
    label: "",
    value: "",
  },
];
const INCLUDE_ITEM_PACKAGE_LABEL = [
  {
    id: 1,
    label: "Name",
    value: "name",
  },
  {
    id: 2,
    label: "Code",
    value: "code",
  },

  {
    id: 3,
    label: "Relief By",
    value: "reliefBy",
  },
  {
    id: 4,
    label: "Relief",
    value: "relief",
  },

  {
    id: 6,
    label: "Qty",
    value: "quantaty",
  },
  {
    id: 7,
    label: "",
    value: "",
  },
];
const EXCLUDE_CATEGORY_LABEL = [
  {
    id: 1,
    label: "Category Name",
    value: "categoryName",
  },
  {
    id: 2,
    label: "Sub Category Name",
    value: "subCategoryName",
  },

  {
    id: 3,
    label: "",
    value: "",
  },
];
const EXCLUDE_DEPARTMENT_LABEL = [
  {
    id: 1,
    label: "Department Name",
    value: "departmentName",
  },

  {
    id: 3,
    label: "",
    value: "",
  },
];
const EXCLUDE_ITEM_PACKAGE_LABEL = [
  {
    id: 1,
    label: "Item",
    value: "item",
  },

  {
    id: 3,
    label: "Code",
    value: "code",
  },
  {
    id: 3,
    label: "",
    value: "",
  },
];
const MULTIPLE_SURGERY_LABEL = [
  {
    id: 1,
    label: "Surgery Expense Order",
    value: "surgeryExpenseOrder",
  },

  {
    id: 3,
    label: "Discount %",
    value: "discount",
  },
  {
    id: 3,
    label: "",
    value: "",
  },
];

export default function MasterReliefAdd() {
  const [includedCategory, setIncludedCategory] = useState([]);
  const [includedDepartment, setIncludedDepartment] = useState([]);
  const [includedItemPackage, setIncludedItemPackage] = useState([]);
  const [excludedItemPackage, setExcludedItemPackage] = useState([]);
  const [excludedCategory, setExcludedCategory] = useState([]);
  const [excludedDepartment, setExcludedDepartment] = useState([]);
  const [multipleSurgery, setMultipleSurgery] = useState([]);
  const navigate = useNavigate();

  const handleRemoveTableRow = (rowIndex, currentElement, currentState) => {
    currentState(currentElement?.filter((_, index) => index !== rowIndex));
  };

  const handleAddTableRow = (currentElement, currentState, newRowData) => {
    currentState([...currentElement, newRowData]);
  };
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box component="form" sx={{ width: "100%", pr: "90px", py: "20px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "20px",
            }}
          >
            <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
              Add Relief Details
            </Typography>
            <IconButton onClick={() => navigate(-1)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Details
            </Typography>
            <Grid container spacing={2}>
              {/* item name */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="reliefType"
                  label="Relief Type"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              {/* item code */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="name"
                  label="Name"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              {/* hsn code */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="code"
                  label="Code"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="applicableOn"
                  label="Applicable On"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControlLabel
                  control={<Checkbox name="active" />}
                  sx={{ height: "57px" }}
                  label="Active"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControlLabel
                  control={<Checkbox name="displayValidityDate" />}
                  sx={{ height: "57px" }}
                  label="Display Validity Date"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControlLabel
                  control={<Checkbox name="nonIncome" />}
                  sx={{ height: "57px" }}
                  label="Non Income"
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Details
            </Typography>
            <Grid container spacing={2}>
              {/* item name */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="name"
                  label="Name"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              {/* item code */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="address"
                  label="Address"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              {/* hsn code */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="phone"
                  label="Phone"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="companyName"
                  label="Company Name"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="emailAddress"
                  label="Email Address"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="tpaName"
                  label="TPA Name"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Other
            </Typography>
            <Grid container spacing={2}>
              {/* item name */}
              <Grid item xs={12} sm={6} md={4}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Relief Percent"
                      sx={{ bgcolor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      placeholder="%"
                      sx={{ bgcolor: "white" }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* item code */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="address"
                  label="Relief Applicable On Price"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              {/* hsn code */}
              <Grid item xs={12} sm={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="isReliefApplicableToSurvices" />}
                  label="Is Relief Applicable to Services"
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  name="nonApplicableRelief"
                  label="Non Applicable Relief"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  placeholder="Max Amt/Item"
                  label="Rs(0 = Infinity)"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  placeholder="Max Total Amt"
                  label="Rs(0 = Infinity)"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <FormControlLabel
              control={<Checkbox name="applicability" />}
              label="Applicability"
            />
          </Box>
          <Box
            sx={{
              border: "1px solid #ccc",

              padding: "4px",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Include Category/Sub Category
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {INCLUDE_CATEGORY_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {includedCategory.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {INCLUDE_CATEGORY_LABEL?.map((column, columnIndex) => (
                        <TableCell
                          key={`${rowIndex}${columnIndex}`}
                          sx={{ color: "#5D6A82" }}
                        >
                          {columnIndex ===
                          INCLUDE_CATEGORY_LABEL?.length - 1 ? (
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  includedCategory,
                                  setIncludedCategory
                                )
                              }
                            />
                          ) : column.value === "percentage" ||
                            column.value === "cash" ||
                            column.value === "quantity" ? (
                            <TextField
                              name={column.value}
                              fullWidth
                              sx={{ bgcolor: "white" }}
                            />
                          ) : (
                            <Autocomplete
                              options={uhidOptions || []}
                              getOptionLabel={(option) => option?.label || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name={column.value}
                                  label={column?.label}
                                  required
                                  fullWidth
                                />
                              )}
                              sx={{ bgcolor: "white" }}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={INCLUDE_CATEGORY_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          includedCategory,
                          setIncludedCategory,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: "1px solid #ccc",

              padding: "4px",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Exclude Category/Sub Category
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {EXCLUDE_CATEGORY_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excludedCategory.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {EXCLUDE_CATEGORY_LABEL?.map((column, columnIndex) => (
                        <TableCell
                          key={`${rowIndex}${columnIndex}`}
                          sx={{ color: "#5D6A82" }}
                        >
                          {columnIndex ===
                          EXCLUDE_CATEGORY_LABEL?.length - 1 ? (
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  excludedCategory,
                                  setExcludedCategory
                                )
                              }
                            />
                          ) : (
                            <Autocomplete
                              options={uhidOptions || []}
                              getOptionLabel={(option) => option?.label || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name={column.value}
                                  label={column?.label}
                                  required
                                  fullWidth
                                />
                              )}
                              sx={{ bgcolor: "white" }}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={EXCLUDE_CATEGORY_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          excludedCategory,
                          setExcludedCategory,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: "1px solid #ccc",

              padding: "4px",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Include Department
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {INCLUDE_DEPARTMENT_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {includedDepartment.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {INCLUDE_DEPARTMENT_LABEL?.map((column, columnIndex) => (
                        <TableCell
                          key={`${rowIndex}${columnIndex}`}
                          sx={{ color: "#5D6A82" }}
                        >
                          {columnIndex ===
                          INCLUDE_DEPARTMENT_LABEL?.length - 1 ? (
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  includedDepartment,
                                  setIncludedDepartment
                                )
                              }
                            />
                          ) : (
                            <Autocomplete
                              options={uhidOptions || []}
                              getOptionLabel={(option) => option?.label || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name={column.value}
                                  label={column?.label}
                                  required
                                  fullWidth
                                />
                              )}
                              sx={{ bgcolor: "white" }}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={INCLUDE_DEPARTMENT_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          includedDepartment,
                          setIncludedDepartment,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: "1px solid #ccc",

              padding: "4px",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Exclude Department
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {EXCLUDE_DEPARTMENT_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excludedDepartment.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {EXCLUDE_DEPARTMENT_LABEL?.map((column, columnIndex) => (
                        <TableCell
                          key={`${rowIndex}${columnIndex}`}
                          sx={{ color: "#5D6A82" }}
                        >
                          {columnIndex ===
                          EXCLUDE_DEPARTMENT_LABEL?.length - 1 ? (
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  excludedDepartment,
                                  setExcludedDepartment
                                )
                              }
                            />
                          ) : (
                            <Autocomplete
                              options={uhidOptions || []}
                              getOptionLabel={(option) => option?.label || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name={column.value}
                                  label={column?.label}
                                  required
                                  fullWidth
                                />
                              )}
                              sx={{ bgcolor: "white" }}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={EXCLUDE_DEPARTMENT_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          excludedDepartment,
                          setExcludedDepartment,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: "1px solid #ccc",

              padding: "4px",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Include Item/Package
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {INCLUDE_ITEM_PACKAGE_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {includedItemPackage.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {INCLUDE_ITEM_PACKAGE_LABEL?.map(
                        (column, columnIndex) => (
                          <TableCell
                            key={`${rowIndex}${columnIndex}`}
                            sx={{ color: "#5D6A82" }}
                          >
                            {columnIndex ===
                            INCLUDE_ITEM_PACKAGE_LABEL?.length - 1 ? (
                              <Close
                                sx={{ cursor: "pointer", fontSize: "18px" }}
                                onClick={() =>
                                  handleRemoveTableRow(
                                    rowIndex,
                                    includedItemPackage,
                                    setIncludedItemPackage
                                  )
                                }
                              />
                            ) : (
                              <Autocomplete
                                options={uhidOptions || []}
                                getOptionLabel={(option) => option?.label || ""}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    name={column.value}
                                    label={column?.label}
                                    required
                                    fullWidth
                                  />
                                )}
                                sx={{ bgcolor: "white" }}
                              />
                            )}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={INCLUDE_ITEM_PACKAGE_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          includedItemPackage,
                          setIncludedItemPackage,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: "1px solid #ccc",

              padding: "4px",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Exclude Item/Package
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <FormControlLabel
                control={<Checkbox name="allItems" />}
                sx={{ height: "57px" }}
                label="All Items"
              />
              <FormControlLabel
                control={<Checkbox name="allPackages" />}
                sx={{ height: "57px" }}
                label="All Packages"
              />
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {EXCLUDE_ITEM_PACKAGE_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excludedItemPackage.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {EXCLUDE_ITEM_PACKAGE_LABEL?.map(
                        (column, columnIndex) => (
                          <TableCell
                            key={`${rowIndex}${columnIndex}`}
                            sx={{ color: "#5D6A82" }}
                          >
                            {columnIndex ===
                            EXCLUDE_ITEM_PACKAGE_LABEL?.length - 1 ? (
                              <Close
                                sx={{ cursor: "pointer", fontSize: "18px" }}
                                onClick={() =>
                                  handleRemoveTableRow(
                                    rowIndex,
                                    excludedItemPackage,
                                    setExcludedItemPackage
                                  )
                                }
                              />
                            ) : (
                              <Autocomplete
                                options={uhidOptions || []}
                                getOptionLabel={(option) => option?.label || ""}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    name={column.value}
                                    label={column?.label}
                                    required
                                    fullWidth
                                  />
                                )}
                                sx={{ bgcolor: "white" }}
                              />
                            )}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={EXCLUDE_ITEM_PACKAGE_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          excludedItemPackage,
                          setExcludedItemPackage,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box
              sx={{
                border: "1px solid #ccc",
                width: "45%",
                padding: "4px",
                borderRadius: "12px",
                mb: "30px",
                p: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
                Document
              </Typography>

              <Autocomplete
                options={uhidOptions || []}
                getOptionLabel={(option) => option?.label || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="consultationCharge"
                    label="Consulation Charge"
                    required
                    fullWidth
                  />
                )}
                sx={{ bgcolor: "white" }}
              />

              <TextField
                name="durationOfVerification"
                label="Duration of Verification"
                placeholder="Days"
                sx={{ bgcolor: "white" }}
              />
            </Box>
            <Box
              sx={{
                border: "1px solid #ccc",
                width: "45%",
                padding: "4px",
                borderRadius: "12px",
                mb: "30px",
                p: "20px",
              }}
            >
              <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
                Auto Apply Scheme
              </Typography>

              <Autocomplete
                options={uhidOptions || []}
                getOptionLabel={(option) => option?.label || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="consultationCharge"
                    label="Scheme"
                    required
                    fullWidth
                  />
                )}
                sx={{ bgcolor: "white" }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid rgba(223, 232, 239, 1)",
              borderRadius: "8px",
              mb: "30px",
              p: "20px",
            }}
          >
            <FormControlLabel
              control={<Checkbox name="reliefOnMultipleSurgery" />}
              sx={{ height: "57px" }}
              label="Relief On Multiple Surgery"
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "25px",
                mb: "15px",
              }}
            >
              <Typography>Surgery Relief Type</Typography>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="position"
                defaultValue="sameDaySameSurgeon"
              >
                <FormControlLabel
                  value="sameDaySameSurgeon"
                  control={<Radio />}
                  label="Same Day Same Surgeon"
                />
                <FormControlLabel
                  value="visitWise"
                  control={<Radio />}
                  label="Visit Wise"
                />
              </RadioGroup>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {MULTIPLE_SURGERY_LABEL?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {multipleSurgery.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {MULTIPLE_SURGERY_LABEL?.map((column, columnIndex) => (
                        <TableCell
                          key={`${rowIndex}${columnIndex}`}
                          sx={{ color: "#5D6A82" }}
                        >
                          {columnIndex ===
                          MULTIPLE_SURGERY_LABEL?.length - 1 ? (
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  multipleSurgery,
                                  setMultipleSurgery
                                )
                              }
                            />
                          ) : (
                            <TextField
                              required
                              name={column.value}
                              value={row[column.value] || ""}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={MULTIPLE_SURGERY_LABEL?.length}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          multipleSurgery,
                          setMultipleSurgery,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ display: "flex", gap: 1, pt: "15px" }}>
              <Typography sx={{ fontWeight: "bold" }}>Note:</Typography>
              <Typography>
                Lowest Surgery Expense Order Will Get Highest Priority
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
